import { combineReducers } from "redux";
import { registration, getOtp, verifyOtp, auth } from "./authentication.reducer";
import {
  adminStats,
  bankInfo,
  bhareeAdminBasicTable,
  brands,
  dealOfTheDay,
  cart,
  enquiry,
  sellerAddress,
  buyerAddress,
  companyInfo,
  countries,
  countryStates,
  countryStateCities,
  currentProduct,
  factoryInfo,
  filters,
  liveOffers,
  panleCurrentView,
  roles,
  roletypes,
  sellertypes,
  subscriptionPlans,
  checkoutItems,
  orders,
  currentOrder,
  calculationsFile,
  payment,
  calculatedPrice,
  appconfig,
  gstStates,
  checkEmailVerified,
  sendEmailVerificationLink,
  unreadNotifications,
  guestJWTToken,
  vehicleTypes,
  currentVehicleLoad,
  vehicleLoadStatistics,
} from "./structure.reducer";
import { userBussinessInfomation, userList, userSubscriptionInfo } from "./user.reducer";
import { requestCall } from "./requestCall.reducer";
import { liveOfferProductsList, products, productsList } from "./products.reducer";
import { serviceTaxDetails } from "./service.tax.details";
import { addresses } from "./addresses.reducer";

const rootReducer = combineReducers({
  auth,
  registration,
  addresses,
  requestCall,
  roles,
  roletypes,
  sellertypes,
  subscriptionPlans,
  brands,
  dealOfTheDay,
  userBussinessInfomation,
  userSubscriptionInfo,
  getOtp,
  verifyOtp,
  bhareeAdminBasicTable,
  products,
  productsList,
  userList,
  serviceTaxDetails,
  filters,
  panleCurrentView,
  factoryInfo,
  bankInfo,
  liveOffers,
  adminStats,
  companyInfo,
  currentProduct,
  cart,
  enquiry,
  sellerAddress,
  buyerAddress,
  liveOfferProductsList,
  countries,
  countryStates,
  countryStateCities,
  checkoutItems,
  orders,
  currentOrder,
  calculationsFile,
  calculatedPrice,
  payment,
  appconfig,
  gstStates,
  checkEmailVerified,
  sendEmailVerificationLink,
  unreadNotifications,
  guestJWTToken,
  vehicleTypes,
  currentVehicleLoad,
  vehicleLoadStatistics,
});

export default rootReducer;
